import { menuFirsts } from "../../constants/menu";
import Agencies from "../../page/agencies/agencies";

const routeDepartment = [
    {
        ...menuFirsts.DEPARTMENT,
        key: menuFirsts.DEPARTMENT.key,
        name: menuFirsts.DEPARTMENT.name,
        code: menuFirsts.DEPARTMENT.code,
        textName: menuFirsts.DEPARTMENT.textName,
        active: false,
        appBar: true,
        component: Agencies
    },

]

export default routeDepartment